import { useMutation } from 'react-query';

import { Api } from 'shared/types';
import { UpdatingOptionsState } from 'shared/blocks/one-shop/updating-options/reducer';

type Props = {
  updatingOptionsValues: UpdatingOptionsState;
  getUpdatingOptionsOfferModification: Api | null;
};

export const useUpdatingOptionsOfferModification = ({
  updatingOptionsValues,
  getUpdatingOptionsOfferModification
}: Props) => {
  return useMutation(async () => {
    if (!getUpdatingOptionsOfferModification) {
      return;
    }
    if (!updatingOptionsValues.saleDeviceId) {
      throw new Error('Missing required parameters: saleDeviceId');
    }
    const params = new URLSearchParams({
      saleDeviceId: updatingOptionsValues.saleDeviceId
    });

    const products = [
      ...Object.keys(updatingOptionsValues.formValues.minorsOffers)
        .filter(id => updatingOptionsValues.formValues.minorsOffers[id])
        .map(id => ({ id })),
      { id: updatingOptionsValues.formValues.majorOfferId }
    ];

    const url = `${
      getUpdatingOptionsOfferModification.url
    }?${params.toString()}`;

    const response = await fetch(url, {
      method: getUpdatingOptionsOfferModification.method,
      headers: {
        Authorization: `AuthBypass ${updatingOptionsValues.headers.token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        equipmentId: updatingOptionsValues.renewalNumber,
        payment: {
          amount: updatingOptionsValues.payment.amount,
          currencyCode: updatingOptionsValues.payment.currency,
          paymentMeanId: 'TS',
          internationalPhoneNumber:
            updatingOptionsValues.formValues.phoneNumber,
          epaymentOperatorId: updatingOptionsValues.formValues.selectedOperator
        },
        products
      })
    });

    if (!response.ok) {
      throw new Error('Failed to initiate updating options offer modification');
    }

    const data = await response.json();
    return { orderId: data.orderId, correlationId: data.correlationId };
  });
};
